import React from 'react'

import { AskWidget } from '../../components/AskWidget'

// Stays mounted across help-page navigations, keeping the ask conversation alive.
export default function HelpLayout({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <>
      {children}
      <AskWidget />
    </>
  )
}
